import { render, staticRenderFns } from "./TypeEvidenceCategoryForm.vue?vue&type=template&id=db9ae25e&"
import script from "./TypeEvidenceCategoryForm.vue?vue&type=script&lang=js&"
export * from "./TypeEvidenceCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports